export default {"src":"/_next/static/media/green.79a70181.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};